import { RightOutlined } from '@ant-design/icons';
import {
  TASK_PRIORITY_LABELS,
  TASK_STATUS_LABELS,
  taskPriorityTagClass,
  taskStatusTagClass,
} from '@/constants/task';
import type { TaskListItem } from '@/types/task';
import { formatDateTime } from '@/utils/format-date';

interface MobileTaskCardProps {
  task: TaskListItem;
  onClick?: () => void;
}

export function MobileTaskCard({ task, onClick }: MobileTaskCardProps) {
  const dueText = formatDateTime(task.dueAt);

  return (
    <article
      className="mobile-card mobile-card--link"
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={(event) => {
        if (onClick && (event.key === 'Enter' || event.key === ' ')) {
          onClick();
        }
      }}
    >
      <div className="mobile-card__header">
        <span className="mobile-card__title">{task.title}</span>
        <span className={taskStatusTagClass(task.status)}>{TASK_STATUS_LABELS[task.status]}</span>
      </div>
      <div className="mobile-card__meta">
        负责人：{task.owner?.name ?? '—'}
        {task.overdue ? ' · 已逾期' : ''}
      </div>
      <div className="mobile-task-card__tags">
        <span className={taskPriorityTagClass(task.priority)}>
          {TASK_PRIORITY_LABELS[task.priority]}
        </span>
        <span className="mobile-task-card__due">截止 {dueText}</span>
      </div>
      {onClick ? (
        <div className="mobile-card__footer">
          <span>查看详情</span>
          <RightOutlined />
        </div>
      ) : null}
    </article>
  );
}
